import React from 'react';
import { OpposingQuotes } from '.';
import Context from '../Utilities';

const { Fragment } = window.wp.element;

function Similar() {
    return (
        <Context.Consumer>
            {({ type }) => {
                return (
                    <Fragment>
                        <div id="similar">
                            <p className="subhead">
                                Let’s explore what other Americans might do at a
                                similar dinner.
                            </p>
                            <div id="bar">
                                <img
                                    className="fourPeople"
                                    src={`https://assets.pewresearch.org/interactives/politics/2019/dinner-party/Path_${type}/Path_${type}_4.png`}
                                    alt="Illustration of four dinner guests sitting at a table. The user's position is highlighted."
                                />
                            </div>
                            <div id="quotesContainer">
                                <OpposingQuotes />
                            </div>
                            <p>
                                There are many reasons why Americans may or may
                                not want to talk about Donald Trump with a group
                                of strangers. For many, politics and Trump are
                                difficult topics to engage in. And in settings
                                with people they don’t know well, the decision
                                to speak up or not can be complicated. Whether
                                they choose to involve themselves in the
                                conversation or avoid doing so, both approvers
                                and disapprovers of Donald Trump illustrate how
                                political discussions in this era can be hard to
                                navigate.
                            </p>
                            <div className="question">
                                <p>
                                    Explore more reasons why Americans would
                                    decide to share – or not share – their
                                    opinions of Trump below.
                                </p>
                            </div>
                        </div>
                    </Fragment>
                );
            }}
        </Context.Consumer>
    );
}

export default Similar;
